import { render, staticRenderFns } from "./SAMailAuthentication.html?vue&type=template&id=21384fda&scoped=true&"
import script from "./SAMailAuthentication.ts?vue&type=script&lang=ts&"
export * from "./SAMailAuthentication.ts?vue&type=script&lang=ts&"
import style0 from "./SAMailAuthentication.css?vue&type=style&index=0&id=21384fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21384fda",
  null
  
)

export default component.exports